/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetBbsContentInfoRespVo } from './GetBbsContentInfoRespVo';
import {
    GetBbsContentInfoRespVoFromJSON,
    GetBbsContentInfoRespVoFromJSONTyped,
    GetBbsContentInfoRespVoToJSON,
    GetBbsContentInfoRespVoToJSONTyped,
} from './GetBbsContentInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseGetBbsContentInfoRespVo
 */
export interface ResponseGetBbsContentInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseGetBbsContentInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseGetBbsContentInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {GetBbsContentInfoRespVo}
     * @memberof ResponseGetBbsContentInfoRespVo
     */
    data?: GetBbsContentInfoRespVo;
}

/**
 * Check if a given object implements the ResponseGetBbsContentInfoRespVo interface.
 */
export function instanceOfResponseGetBbsContentInfoRespVo(value: object): value is ResponseGetBbsContentInfoRespVo {
    return true;
}

export function ResponseGetBbsContentInfoRespVoFromJSON(json: any): ResponseGetBbsContentInfoRespVo {
    return ResponseGetBbsContentInfoRespVoFromJSONTyped(json, false);
}

export function ResponseGetBbsContentInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetBbsContentInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : GetBbsContentInfoRespVoFromJSON(json['data']),
    };
}

export function ResponseGetBbsContentInfoRespVoToJSON(json: any): ResponseGetBbsContentInfoRespVo {
    return ResponseGetBbsContentInfoRespVoToJSONTyped(json, false);
}

export function ResponseGetBbsContentInfoRespVoToJSONTyped(value?: ResponseGetBbsContentInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': GetBbsContentInfoRespVoToJSON(value['data']),
    };
}

